import { render, staticRenderFns } from "./calmDialog.vue?vue&type=template&id=2bca09f0&scoped=true&"
import script from "./calmDialog.vue?vue&type=script&lang=js&"
export * from "./calmDialog.vue?vue&type=script&lang=js&"
import style0 from "./calmDialog.vue?vue&type=style&index=0&id=2bca09f0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bca09f0",
  null
  
)

export default component.exports